<template>
    <NxSelect
    :value="localValue"
    :options="listOptions"
    labelText="Tipo de Planilha:"
    id="selectTipoPlanilha"
    placeholder="Selecione o Tipo"
    @update:value="handleValueUpdate"
  ></NxSelect>
</template>
<script>
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxSelectPlanilhaTipos',
  mixins: [ useReactiveModelMixin('value') ],
  data () {
    return {
      listOptions: [
        {value: 'ANOTACOESNEGATIVAS', text: 'ANOTAÇÕES NEGATIVAS'},
        {value: 'ASSOCIADOS', text: 'ASSOCIADOS'},
        {value: 'BENSASSOCIADOS ', text: 'BENS ASSOCIADO'},
        {value: 'CAPTACAOREMUNERADADIARIA', text: 'CAPTAÇÃO REMUNERAÇÃO DIÁRIA'},
        {value: 'CARTAODECREDITO', text: 'CARTÃO DE CRÉDITO'},
        {value: 'CONSORCIO', text: 'CARTEIRA CONSÓRCIO'},
        {value: 'SEGURO', text: 'CARTEIRA SEGUROS'},
        {value: 'COBRANCAGERAIS', text: 'COBRANÇA GERAL'},
        {value: 'CONTACAPITAL', text: 'CONTA CAPITAL'},
        {value: 'CONTACORRENTE', text: 'CONTA CORRENTE'},
        {value: 'POUPANCA', text: 'CONTA POUPANÇA'},
        {value: 'CONTRATOSVIGENTES', text: 'CONTRATOS VIGENTES'},
        {value: 'ENDIVIDAMENTO_SICOOB', text: 'ENDIVIDAMENTO SICOOB'},
        {value: 'ENDIVIDAMENTO_SFN', text: 'ENDIVIDAMENTO SFN'},
        {value: 'FUNCIONARIOS', text: 'FUNCIONÁRIOS'},
        {value: 'GARANTIADEOPERACOES', text: 'GARANTIA DE OPERAÇÕES'},
        {value: 'GRUPOECONOMICO', text: 'GRUPO ECONÔMICO'},
        {value: 'IAP', text: 'IAP'},
        {value: 'MARGEMCONTRIBUICAO', text: 'MARGEM DE CONTRIBUIÇÃO'},
        {value: 'MOVIMENTACAODIARIACONTA', text: 'MOVIMENTAÇÃO DIÁRIA CONTA'},
        {value: 'PAGAMENTOPARCELA', text: 'PAGAMENTO PARCELA'},
        {value: 'PLD', text: 'PLD'},
        {value: 'RELACIONAMENTOASSOCIADO', text: 'RELACIONAMENTO ASSOCIADOS'},
        {value: 'RISCO', text: 'RISCO'},
        {value: 'SALDOMEDIOCAPTACAO', text: 'SALDO MÉDIO CAPTAÇÃO'},
        {value: 'SALDOMEDIOCCO', text: 'SALDO MÉDIO CCO'}
      ],
      selected: null
    }
  },
  methods: {
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectPlanilhaTipos.vue